import { useEffect } from 'react'
import { useGLTF, useMatcapTexture } from '@react-three/drei'
import { useSpring, a } from '@react-spring/three'
import { DracoLevelModel } from '../types/DracoLevelModel'

export default function Icon() {
  const { nodes } = useGLTF('/level-react-draco.glb') as DracoLevelModel
  const [matcap] = useMatcapTexture('65A0C7_C3E4F8_A7D5EF_97CAE9', 1024)
  const [springs, api] = useSpring(() => ({ rotation: [0.8, 1.1, -0.4], position: [-0.79, 1.3, 0.62], config: { mass: 2, tension: 200 } }))
  useEffect(() => {
    let timeout: NodeJS.Timeout
    let floating = false
    const bounce = () => {
      api.start({ rotation: [0.8 - (floating ? 0.8 + Math.PI * 1.8 : 0), 1.1, -0.4], position: [-0.79, floating ? 1.4 : 1.3, 0.62] })
      floating = !floating
      timeout = setTimeout(bounce, 1.5 * 1000)
    }
    bounce()
    return () => clearTimeout(timeout)
  }, [])
  return (
    <>
      {/* @ts-ignore: https://github.com/pmndrs/react-spring/issues/1515 */}
      <a.mesh geometry={nodes.React.geometry} {...springs}>
        <meshMatcapMaterial matcap={matcap} />
      </a.mesh>
    </>
  )
}
